import React from 'react';

const WorkProjects = () => {
    return (
        <div>
            <h1 className="text-2xl font-normal text-primary">
                Job Intern Project 


            </h1>
                            <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">I have done project with jobs/internship.</h1>

            <div className="grid lg:grid-cols-2 gap-2 py-2">
                <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/S0Nf3PL/20230904-123939.jpg"
                            class=""

                            alt="Louvre" />
                        <a target="_blank" href="https://taskla-hr.netlify.app/">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
                </div>
                <div className="">
                   
                </div>

            </div>
            <h1 className=" font-bold">More Project comming</h1>
        </div>
    );
};

export default WorkProjects;